import { useContext } from "react";

import { AttachmentsContext } from "@RequestFormV2/sections/Attachments/context/AttachmentsProvider";

export function useAttachments() {
  const context = useContext(AttachmentsContext);
  if (!context) {
    throw new Error("useAttachments must be used within an AttachmentsProvider");
  }
  return context;
}
